const needsBankRedirect = (category) => {
  return category.parent?.lazyBankSelection && !category.id?.includes('direct-withdraw');
};

export default needsBankRedirect;
